import React from "react";
import MarkdownPage from "../MarkdownPage";

export default () => {
  return (
    <div>
      <MarkdownPage filename="canvas" />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/guides/CanvasRendering.js